import React, { useState } from 'react';
import useBranches from '../lib/useBranches';
export default function BranchVisitNotice({ vendor }) {
  if (!vendor?.branch) return null;
  return <BranchNotice vendor={vendor} />;
}
function BranchNotice({ vendor }) {
  const { currentBranch, loading, select, error } = useBranches();
  const [busy, setBusy] = useState(false), [saveError, setSaveError] = useState('');
  if (loading || !vendor?.branch || vendor.branch.id === currentBranch?.id) return null;
  const change = async () => {
    setBusy(true); setSaveError('');
    try { await select(vendor.branch); }
    catch (error) { setSaveError(error.response?.data?.message || 'Unable to change area.'); }
    finally { setBusy(false); }
  };
  return <aside role="status" className="mx-auto my-3 max-w-7xl rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-950">
    <p>This store is in <strong>{vendor.branch.name}</strong>{currentBranch ? `, outside your selected area (${currentBranch.name})` : ''}. Change area to browse more products there. Delivery requires an address in {vendor.branch.name}.</p>
    <button type="button" disabled={busy || Boolean(error)} onClick={change} className="mt-2 font-semibold underline">{busy ? 'Changing area...' : `Change to ${vendor.branch.name}`}</button>
    {(saveError || error) && <p role="alert">{saveError || error}</p>}
  </aside>;
}
